import SentimentTrackerOnboardingNotCompletedContainer from "./SentimentTrackerOnboardingNotCompletedContainer";
import SentimentTrackerOnboardingNotCompletedStore from "./SentimentTrackerOnboardingNotCompletedStore";

export default SentimentTrackerOnboardingNotCompletedStore(SentimentTrackerOnboardingNotCompletedContainer);